import { Button, Modal, Spinner } from "react-bootstrap";
import { ResumenAgendamiento } from "../../agendamientoResumido/ResumenAgendamiento";
import {
  AgendamientoResumido,
  eliminar,
} from "../../../services/agendamientosServicios";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEY_LISTAR_AGENDAMIENTOS_ACTIVOS } from "../../../services/propietariosServicios";

export const AgendamientoModal = ({
  agendamiento,
  show,
  onClose,
}: {
  agendamiento: AgendamientoResumido | undefined;
  show: boolean;
  onClose: () => void;
}) => {
  const queryClient = useQueryClient();
  const mutacionEliminar = useMutation(eliminar, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_LISTAR_AGENDAMIENTOS_ACTIVOS],
      });
      onClose();
    },
  });

  const onEliminarClick = () => {
    if (agendamiento) {
      mutacionEliminar.mutate({
        idAgendamiento: agendamiento!!.id,
        tipoServicio: agendamiento.tipoServicio,
      });
    }
  };

  if (mutacionEliminar.isError) {
    return <ServerErrorModal onClose={onClose} />;
  }

  return (
    <Modal show={show}>
      {!!agendamiento && (
        <>
          <Modal.Header>
            <h4>Resúmen de Agendamiento</h4>
          </Modal.Header>
          <Modal.Body>
            <ResumenAgendamiento agendamientoResumido={agendamiento!} />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={onEliminarClick}>
              {mutacionEliminar.isLoading && (
                <Spinner size="sm" animation="border" />
              )}
              {!mutacionEliminar.isLoading && "Eliminar"}
            </Button>
            <Button onClick={onClose}>Cerrar</Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};
